<template>
  <div class="page">
    <div class="box">
        <sectionTitle :titleObj="titleObj"></sectionTitle>
        <div class="content" v-html="agreement">

        </div>
        <el-checkbox v-if="agreement&&agreement!=''" class="agree" v-model="checked" size="medium">我已同意并阅读以上条款协议</el-checkbox>
        <div class="flex-center button-box" v-if="agreement&&agreement!=''">
            <el-button @click="toRegister('/register/personal')" type="warning" class="button" :disabled="!checked">个人用户注册</el-button>
            <el-button @click="toRegister('/register/enterprise')" type="warning" class="button" :disabled="!checked">企业用户注册</el-button>
        </div>
    </div>
  </div>
</template>

<script>
import sectionTitle from '@/components/sectionTitle.vue';
import {findRoute} from '@/utils/routerHelper.js';
import {queryForm}from '@/api/api.js';
export default {
    components:{
        sectionTitle
    },
    data(){
        return {
            titleObj:{
                title:'注册',
                subtitle:'REGISTER'
            },
            checked:false,
            agreement:''
        }
    },
    created(){
        this.getAgreement()
    },
    methods:{
        getAgreement(){
            queryForm(
                {
                    "formKey": "vZ6rfQCB",
                    "queryId": "279",
                    "queryParams": {
                        "select1767949556557label": "网页"
                    },
                    "size": 1,
                    "current": 0
                }
            ).then(res=>{
                if(res.data.code==200){
                    this.agreement=res.data.data.rows[0].rich_text1767949564609
                }
            })
        },
        toRegister(pathData){
            this.$store.commit('routerData/changeRouterList',[])
            this.$router.push(pathData)
            let routerList=this.$store.state.routerData.routerList
            let data=findRoute(this.$router.options.routes, pathData)
            let data2=findRoute(this.$router.options.routes, '/register/agreement')
            routerList.push(data2)
            routerList.push(data)
            this.$store.commit('routerData/changeRouterList',routerList)
        }
    }
}
</script>

<style lang="less" scoped>
.box{
    width:62.5%;
    margin:0 auto;
    padding-bottom: 187px;
    .content{
        // min-height:800px;
        font-size: 20px;
        color: #333333;
    }
    .agree{
        margin:48px 0;
    }
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
  color: #ED9D26;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #ED9D26;
  border-color: #ED9D26;
}
::v-deep .el-checkbox__input.is-focus .el-checkbox_inner{
    border-color: #ED9D26;
}
::v-deep .el-checkbox_inner:hover{
    border-color: #ED9D26;
}
button{
    height: 52px;
    line-height: 24px;
    background: #ed9d26;
    border-radius: 8px;
    padding:0 24px;
    border:none;
    margin-right:16px;
    font-size: 20px;
    color: #ffffff;
    cursor: pointer;
}
::v-deep .el-checkbox{
    font-size: 18px;
}
::v-deep .el-checkbox__label {
    font-size: 18px;
}
.button-box{

}
</style>